import { render, staticRenderFns } from "./StimulusChips.vue?vue&type=template&id=5abedc86&scoped=true"
import script from "./StimulusChips.vue?vue&type=script&lang=js"
export * from "./StimulusChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abedc86",
  null
  
)

export default component.exports